module.exports = {
      id: "user-usage",
      viewBox: "0 0 158 158",
      url: __webpack_public_path__ + "svg-sprite.svg#user",
      toString: function () {
        return this.url;
      }
    }